export default "__VITE_ASSET__A96INl0H__"